import { render, staticRenderFns } from "./Dialog_UpdateClassPackage.vue?vue&type=template&id=2dd0a649&scoped=true&"
import script from "./Dialog_UpdateClassPackage.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateClassPackage.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_UpdateClassPackage.vue?vue&type=style&index=0&id=2dd0a649&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0a649",
  null
  
)

export default component.exports